import { render, staticRenderFns } from "./UploadCollection.vue?vue&type=template&id=ad711b14&"
import script from "./UploadCollection.vue?vue&type=script&lang=js&"
export * from "./UploadCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports